import React from 'react'
import { useTheme } from '@mui/material'
import get from 'lodash/get'

import { Icons, IconName } from '@/assets/icons'

import { PaletteLiteral } from './theme-provider/theme.tsx'

type IconSizes = 'initial' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | string
export interface IconProps {
  name: IconName
  size?: IconSizes
  colorScheme?: PaletteLiteral | 'none' | 'currentColor'
}

const SIZE_MAP: Record<Exclude<IconSizes, 'initial'>, number> = {
  xs: 10,
  sm: 14,
  px16: 16,
  md: 18,
  lg: 24,
  px32: 32,
  xl: 64,
}

export const Icon = ({ name, size = 'lg', colorScheme = 'icons.main' }: IconProps): React.ReactElement => {
  const { palette } = useTheme()
  const IconComponent = Icons[name]

  return (
    <IconComponent
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      fill={
        ['none', 'currentColor'].includes(colorScheme) ? colorScheme : get(palette, colorScheme, palette.icons.main)
      }
      {...(size !== 'initial' && {
        width: SIZE_MAP[size],
        height: SIZE_MAP[size],
      })}
    />
  )
}
